import React from "react";

const LinearBg = () => {
  return <div className="nav-linear-bg"></div>;
};

export default LinearBg;
